import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import logo from "../assets/logo-black.png";

export default function Logo({ size = 80, variant = "dark", clickable = true }) {
    const navigate = useNavigate();
    const { isAuthenticated } = useAuth();

    const handleClick = () => {
        if (!clickable) return;
        if (isAuthenticated) {
            navigate("/dashboard");
        } else {
            navigate("/");
        }
    };

    return (
        <Box sx={{ cursor: clickable ? "pointer" : "default", textAlign: "center" }} onClick={clickable ? handleClick : undefined}>
            <img
                src={logo}
                alt="oncallCME Logo"
                style={{
                    height: size,
                    filter: variant === "light" ? "brightness(0) invert(1)" : "none"
                }}
            />
        </Box>
    );
}
